import { CameraDetails, Gondola, RawCameraDetails, RawGondola } from "../api";
import { CAMERA_TYPES } from "../consts";

const convertCameraDetails = (rawCamera: RawCameraDetails): CameraDetails => ({
  id: rawCamera.camera_id,
  thumbnail: rawCamera.thumbnail,
  imagePng: rawCamera.image_png,
  imageWebp: rawCamera.image_webp,
  height: rawCamera.height,
  width: rawCamera.width,
  cameraType: rawCamera.camera_type,
});

export const processGondolaData = (rawGondolas: RawGondola[]): Gondola[] => {
  return rawGondolas.map((gondola) => {
    const allCameras = gondola.cameras?.map((camera) =>
      convertCameraDetails(camera)
    );

    return {
      id: gondola.id,
      name: gondola.name,
      cameras: allCameras,
      shelfTrackingCameras: allCameras.filter(
        (camera) => camera.cameraType === CAMERA_TYPES.SHELF_TRACKING
      ),
      handTrackingCameras: allCameras.filter(
        (camera) => camera.cameraType === CAMERA_TYPES.HAND_TRACKING
      ),
    };
  });
};
